'use client'

import { Button } from 'ui/button'
import { toast } from 'sonner'
import { useState } from 'react'
import { Dialog, DialogContent, DialogDescription, DialogTitle } from 'ui/dialog'
import { unsubscribeUserAction as unsubscribeAction } from 'components/Premium/UserPremiumActions'

interface PremiumCancelationDialogProps {
    premiumUnsubscribeConfirmationTitle: string
    premiumUnsubscribeConfirmationText: string
    premiumUnsubscribeConfirmationCancel: string
    premiumUnsubscribeConfirmationConfirm: string
    unsubscribeSuccess: string
    unsubscribeError: string
    pathname: string
    open?: boolean
    onClose?: () => void
}

const PremiumCancelationDialog: React.FC<PremiumCancelationDialogProps> = ({
    premiumUnsubscribeConfirmationTitle,
    premiumUnsubscribeConfirmationText,
    premiumUnsubscribeConfirmationCancel,
    premiumUnsubscribeConfirmationConfirm,
    unsubscribeSuccess,
    unsubscribeError,
    pathname,
    open = false,
    onClose
}) => {
    const [isLoading, setIsLoading] = useState(false)

    return (
        <Dialog
            open={open}
            onOpenChange={openState => {
                if (!openState) {
                    if (onClose) onClose()
                    setIsLoading(false)
                }
            }}
        >
            <DialogContent className='flex p-6 flex-col bg-card items-center w-4/5 mx-auto h-auto'>
                <DialogTitle className='mb-4 text-xl font-semibold text-center'>
                    {premiumUnsubscribeConfirmationTitle}
                </DialogTitle>
                <DialogDescription className='mb-6 text-center'>{premiumUnsubscribeConfirmationText}</DialogDescription>
                <div className='flex flex-col sm:flex-row justify-center space-y-3 sm:space-y-0 sm:space-x-4 w-full'>
                    <Button
                        variant='default'
                        onClick={() => onClose && onClose()}
                        className='font-semibold w-full md:w-auto'
                        autoFocus
                    >
                        {premiumUnsubscribeConfirmationCancel}
                    </Button>
                    <Button
                        variant='outline'
                        onClick={async () => {
                            setIsLoading(true)
                            const res = await unsubscribeAction(pathname)
                            if (onClose) onClose()
                            if (res?.status === 'success') {
                                toast.success(unsubscribeSuccess)
                            } else {
                                toast.error(unsubscribeError)
                            }
                            setTimeout(() => {
                                window.dispatchEvent(new CustomEvent('premiumStatusUpdated'))
                            }, 2000)
                        }}
                        loading={isLoading}
                        className='text-destructive border-destructive hover:bg-destructive/10 w-full md:w-auto'
                    >
                        {premiumUnsubscribeConfirmationConfirm}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default PremiumCancelationDialog
